import React from "react";
import ClickToFlyCalculatorContent from "../components/click-to-fly-calculator/click-to-fly-calculator-content";

const ClickToFlyCalculator = () => {
  return <ClickToFlyCalculatorContent />;
};

export default ClickToFlyCalculator;

